import { render, staticRenderFns } from "./stock-panel.vue?vue&type=template&id=47522944"
import script from "./stock-panel.vue?vue&type=script&lang=js"
export * from "./stock-panel.vue?vue&type=script&lang=js"
import style0 from "./stock-panel.vue?vue&type=style&index=0&id=47522944&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports